import { render, staticRenderFns } from "./BuildInspect.vue?vue&type=template&id=862d5674"
import script from "./BuildInspect.vue?vue&type=script&lang=js"
export * from "./BuildInspect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports